<template>
    <div class="bg-lightest radius-normal border-light d-flex flex-wrap text-center mt-2 py-2">
        <div class="col-sm-4 pt-2 pb-2" v-for="personPrice,index in bookingGenderPrices" v-if="getAudienceTypeList  && (personPrice.genderPriceType == 2 || personPrice.genderPriceType == 1 && personPrice.isExcludedFromBilling)">

            <div class="font-weight-600">{{genderPriceName(personPrice)}}</div>

            <div class="medium">{{genderPriceDescription(personPrice)}}</div>

            <!-- only show if price is per person ELSE dont show price -->
            <div class="dark" v-if="reservation.bookingGenderPrices[0].genderPriceType == 2">{{formatPrice(showTicketPrice(personPrice))}} €</div>

            <div class="mt-2">
                <button class="btn fs-largest bg-lightest dark border-medium py-1 px-3 h-100" :disabled="readOnly" @click="subtractPerson(personPrice)"> - </button>
                <input type="number" class="text-center fs-largest darker bg-lighter border-medium radius-normal py-1 px-1 mx-2" :disabled="readOnly" style="width: 3rem;" value="0" @input.lazy="paxManuallyChanged(personPrice)" v-model.number="personPrice.quantityToBook"></input>
                <button class="btn fs-largest bg-lightest dark border-medium py-1 px-3 h-100" :disabled="readOnly" @click="addPerson(personPrice)"> + </button>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'

export default {
    data: function() {
        return {
            bookingGenderPrices: null
        }
    },
    props: {
        reservation: {
            type: Object
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    created: function() {
        this.bookingGenderPrices = this.reservation.bookingGenderPrices


    },
    computed: {
        ...mapGetters([
            'getReservation',
            'getAudienceTypeList'
        ]),
    },
    mixins: [
        reservationsMixin
    ],
    methods: {
        ...mapActions([
            'setReservationCalculations'
        ]),
        genderPriceName: function (personPrice) {
            return this.genderPriceObj(personPrice).name
        },
        genderPriceDescription: function (personPrice) {
            return this.genderPriceObj(personPrice).description
        },
        quantityChanged: function(eventGenderPrice) {
        },
        addPerson: function(eventGenderPrice) {
            //checks if the total of selected tickets are available
            if(!eventGenderPrice.quantityToBook){
                eventGenderPrice.quantityToBook = 0;
            }

            if(this.reservation.event.availabilityType == 1 || this.totalSelectedTickets < this.reservation.event.quantityAvailable){
                eventGenderPrice.quantityToBook ++
            } else {
                this.$toasted.info('No more tickets available');
            }

            this.updateCalculations();
        },
        subtractPerson: function(eventGenderPrice) {
            if(!eventGenderPrice.quantityToBook){
                eventGenderPrice.quantityToBook = 0;
            } else {
                if(eventGenderPrice.quantityToBook > 0)
                eventGenderPrice.quantityToBook --
            }

            this.updateCalculations();
        },
        updateCalculations: function(){
            this.setReservationCalculations(this.reservation);
        }
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// PersonTicketSelector.vue?364c20ea